import Geosuggest from '@ubilabs/react-geosuggest';

import { useDispatch, useSelector } from 'react-redux';

import './input.scss';
import {
	setOneProfileAddress,
	setOneProfileCoords,
} from '@/stores/slices/oneProfileSlice';
import {
	getGmapsApiReady,
	setGmapsApiReady,
} from '../../../stores/slices/mapModelSlice';
import { useEffect, useState } from 'react';

const GeoInput = ({
	name,
	value,
	clazz,
	placeholder,
	register,
	setValue,
	isAgency = false,
	disabled,
	city = false,
	setCoords,
}) => {
	const dispatch = useDispatch();
	const apiReady = useSelector(getGmapsApiReady);

	const [bounds, setBounds] = useState(null);
	const [checkReady, setCheckReady] = useState(false);

	const onSuggestSelect = (suggest) => {
		if (suggest) {
			if (name === 'location' || name === 'address') {
				setValue?.(suggest.description);
				setCoords?.(suggest.location.lat, suggest.location.lng);
			}

			if (name === 'location-create') {
				dispatch(setOneProfileAddress(suggest.description));
				dispatch(
					setOneProfileCoords({
						latitude: suggest.location.lat,
						longitude: suggest.location.lng,
					}),
				);
				setValue?.(suggest.description);
			}
		}
	};

	const onInputChange = (userInput) => {
		if (isAgency) {
			setValue?.(userInput);
		} else {
			if (!userInput) {
				console.warn('Input value clean');
				setValue?.(null);
			} else {
				setValue?.(userInput);
			}
		}
	};

	const getCityBounds = async (city) => {
		const geocodeUrl = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
			city,
		)}&limit=1&addressdetails=1`;

		try {
			const response = await fetch(geocodeUrl);
			if (!response.ok)
				throw new Error(`HTTP, ${response.status}`, response);

			const data = await response.json();

			if (!Array.isArray(data) || !data.length) {
				setBounds(null);
				return;
			}

			const item = data[0];

			if (
				Array.isArray(item.boundingbox) &&
				item.boundingbox.length === 4
			) {
				const [south, north, west, east] = item.boundingbox.map(Number);

				setBounds({
					north,
					south,
					east,
					west,
				});
				return;
			}

			const lat = Number(item.lat);
			const lng = Number(item.lon);
			const radius = 50000;
			const delta = radius / 111320;

			setBounds({
				north: lat + delta,
				south: lat - delta,
				east: lng + delta,
				west: lng - delta,
			});
		} catch (error) {
			console.error('Request error:', error);
		}

		setBounds(null);
	};

	const mapLink = `https://maps.googleapis.com/maps/api/js?key=AIzaSyA81vyhvrBl3jUTFDK6LwYNm317prcxfVo&libraries=places&language=en`;

	const loadScript = async (retryCount = 0) => {
		return new Promise((resolve, reject) => {
			const script = document.createElement('script');
			script.src = mapLink;
			script.async = true;

			script.onload = () => {
				// console.log("%cGoogle Maps API loaded successfully. ", "color: green; font-size: 8px");
				dispatch(setGmapsApiReady(true));
				resolve();
			};

			script.onerror = () => {
				// console.error("%cGoogle Maps API failed to load.", "color: red; font-size: 8px");
				if (retryCount < 5) {
					// console.log(`%cRetrying to load Google Maps API... Attempt: ${retryCount + 1}`, "color: orange; font-size: 8px");
					setTimeout(() => {
						loadScript(retryCount + 1)
							.then(resolve)
							.catch(reject);
					}, 1000);
				} else {
					reject(
						new Error(
							'Google Maps API failed to load after multiple attempts.',
						),
					);
				}
			};

			document.body.appendChild(script);
		});
	};

	useEffect(() => {
		if (!apiReady) {
			loadScript()
				.then(() => {
					// console.log("%cGoogle Maps API loaded successfully. ", "color: green; font-size: 8px");
					dispatch(setGmapsApiReady(true));
				})
				.catch((error) => {
					console.error(
						`%cError loading Google Maps API: ${error}`,
						'color: red; font-size: 8px',
					);
				});
		}
	}, []);

	useEffect(() => {
		if (city) {
			getCityBounds(city).then(() => setCheckReady(true));
		}
	}, [city]);

	return (
		<>
			{typeof window !== 'undefined' &&
				!!apiReady &&
				(checkReady || !city) && (
					<Geosuggest
						inputProps={!!register && { ...register(name) }}
						onChange={onInputChange}
						disabled={disabled}
						initialValue={value}
						inputClassName={`input ${clazz ? clazz : ''}`}
						placeholder={placeholder}
						onSuggestSelect={onSuggestSelect}
						country={'cz'}
						bounds={bounds}
					/>
				)}
		</>
	);
};

export default GeoInput;
